import { Action } from 'redux';
import { CountriesMap, Country, EArticleAlias, IArticle } from '../types';

export const LEGALS_INIT = 'LEGALS_INIT';
export type LEGALS_INIT = typeof LEGALS_INIT;
export interface ILegalsInitAction extends Action<LEGALS_INIT> {
  type: LEGALS_INIT;
}

export const TRANSLATIONS_READY = 'TRANSLATIONS_READY';
export type TRANSLATIONS_READY = typeof TRANSLATIONS_READY;
export interface ITranslationsReadyAction extends Action<TRANSLATIONS_READY> {
  type: TRANSLATIONS_READY;
}

export const LEGALS_COUNTRIES_UPDATE = 'LEGALS_COUNTRIES_UPDATE';
export type LEGALS_COUNTRIES_UPDATE = typeof LEGALS_COUNTRIES_UPDATE;
export interface ILegalsCountriesUpdateAction extends Action<LEGALS_COUNTRIES_UPDATE> {
  type: LEGALS_COUNTRIES_UPDATE;
  countries: CountriesMap;
  mostCommon: Country[];
}

export const LEGALS_REQUEST = 'LEGALS_REQUEST';
export type LEGALS_REQUEST = typeof LEGALS_REQUEST;
export interface ILegalsRequestAction extends Action<LEGALS_REQUEST> {
  type: LEGALS_REQUEST;
  articleAlias: EArticleAlias;
  country: string;
}

export const LEGALS_LOADED = 'LEGALS_LOADED';
export type LEGALS_LOADED = typeof LEGALS_LOADED;
export interface ILegalsLoadedAction extends Action<LEGALS_LOADED> {
  type: LEGALS_LOADED;
  articles: IArticle[];
}

export const LEGALS_FAILED = 'LEGALS_FAILED';
export type LEGALS_FAILED = typeof LEGALS_FAILED;
export interface ILegalsFailedAction extends Action<LEGALS_FAILED> {
  type: LEGALS_FAILED;
  message: string;
}

export type ILegalsAppActions =
  | ILegalsInitAction
  | ITranslationsReadyAction
  | ILegalsRequestAction
  | ILegalsLoadedAction
  | ILegalsFailedAction
  | ILegalsCountriesUpdateAction;
